import { render } from "./HighlightsContent.vue?vue&type=template&id=e170a1d6&ts=true"
import script from "./HighlightsContent.vue?vue&type=script&lang=ts"
export * from "./HighlightsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__